// extracted by mini-css-extract-plugin
var _1 = "TextareaControl-module__animateUploadProgressBarWidth--ExvZ1";
var _2 = "TextareaControl-module__animatedBackground--nfm4Y";
var _3 = "TextareaControl-module__error--y_6Sf";
var _4 = "TextareaControl-module__errorContainer--powJI";
var _5 = "TextareaControl-module__errorIcon--tipti";
var _6 = "TextareaControl-module__input--NFnKZ";
var _7 = "TextareaControl-module__label--UDasM";
var _8 = "TextareaControl-module__textAreaContainer--N3mlK";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "error", _4 as "errorContainer", _5 as "errorIcon", _6 as "input", _7 as "label", _8 as "textAreaContainer" }
